import { render, staticRenderFns } from "./matrix-tag.vue?vue&type=template&id=189180f5&scoped=true"
import script from "./matrix-tag.vue?vue&type=script&lang=js"
export * from "./matrix-tag.vue?vue&type=script&lang=js"
import style0 from "./matrix-tag.vue?vue&type=style&index=0&id=189180f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189180f5",
  null
  
)

export default component.exports